<template>
  <div class="login">
    <el-carousel
      trigger="click"
      :autoplay="true"
      :interval="8000"
      arrow="never"
      :height="height + 'px'"
      @change="handleChange"
    >
      <el-carousel-item v-for="(item, index) in img_list" :key="index">
        <div
          class="item"
          :style="{
            backgroundImage: 'url(' + item.url + ')',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center top',
            backgroundSize: 'cover',
          }"
        ></div>
      </el-carousel-item>
    </el-carousel>
    <!-- 主体 -->
    <div class="wrap">
      <transition name="el-fade-in">
        <div class="copywriting" v-show="copywritingShow">
          <img :src="info.img" alt="" />
        </div>
      </transition>
      <div class="loginBox">
        <div class="tab-head">
          <span
            class="item"
            :class="{ current: currentIndex == index }"
            v-for="(item, index) in tabHead"
            :key="index"
            @click="handleTabs(index)"
            @mouseover="handleMouseover(index)"
            @mouseleave="handleMouseleave(index)"
            >{{ item }}</span
          >
        </div>
        <transition name="el-zoom-in-center">
          <div v-show="show" style="height: 100%">
            <el-form :model="form" :rules="rules" ref="ruleForm">
              <el-form-item prop="username">
                <el-input
                  v-model="form.username"
                  placeholder="用户名/手机号/邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="form.password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="btn"
                  type="primary"
                  @click="handleLogin('ruleForm')"
                  >登 录</el-button
                >
              </el-form-item>
              <el-form-item>
                <p class="tisp">忘记密码？请联系技术人员</p>
              </el-form-item>
            </el-form>
          </div>
        </transition>
        <transition name="el-zoom-in-center">
          <div v-show="!show" class="codeBar">
            <div class="code-show" id="show_weixin_qrcode">
              <wxlogin
                v-if="flag"
                :xbd_appid="xbd_appid"
                :xbd_redirct_uri="xbd_redirct_uri"
              ></wxlogin>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">方舟・辛巴达@2021</div>
  </div>
</template>

<script>
import wxlogin from "@/components/VxLogin/xbd-wxlogin";
import { getLogin } from "@/api/index";
export default {
  data() {
    return {
      currentIndex: 0,
      initialIndex: 0,
      img_list: [
        {
          url: require("../../assets/images/login/item1.jpg"),
          img: require("../../assets/images/login/item1-info.png"),
        },
        {
          url: require("../../assets/images/login/item2.jpg"),
          img: require("../../assets/images/login/item2-info.png"),
        },
      ],
      info: {},
      tabHead: ["账号登录", "扫码登录"],
      height: 0, //初始化高度
      show: true,
      flag: false,
      copywritingShow: true,
      //checked: true,
      xbd_redirct_uri: "",
      xbd_appid: "xbdfa3702abc8537131",
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.height = document.documentElement.clientHeight;
    window.onresize = () => {
      this.height = document.documentElement.clientHeight;
    };
    this.info = this.img_list[this.initialIndex];
    let location = document.location;
    this.xbd_redirct_uri = `${location.protocol}//${location.host}/login/token`;
    if (window != parent) {
      window.parent.document.location = document.location;
    }
  },
  methods: {
    //鼠标移上
    handleMouseover(index) {
      if (this.currentIndex == 1) return;
      if (index == 1) {
        this.flag = true;
      }
    },
    //鼠标移出
    handleMouseleave(index) {
      this.currentIndex == 1 ? (this.flag = true) : (this.flag = false);
    },

    handleChange(e) {
      this.copywritingShow = false;
      this.initialIndex = e;
      this.info = this.img_list[e];
      setInterval(() => {
        this.copywritingShow = true;
      }, 500);
    },
    //tab切换
    handleTabs(index) {
      this.currentIndex = index;
      index == 0 ? (this.show = true) : (this.show = false);
    },
    //用户登录
    handleLogin(ruleForm) {
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          const params = Object.assign({}, this.form);
          console.log(params);
          const result = await getLogin(params);
          console.log(result);
          if (result.code === 1) {
            this.$message.success("登录成功");
            const { fd_id, fd_key, expired } = result.data;
            this.$cookies.set(fd_key, fd_id, expired);
            window.location.href = "/";
          } else {
            this.$message.error(result.msg);
          }
          console.log(result);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //回车事件
    keyupSubmit() {
      document.onkeydown = (e) => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.handleLogin("ruleForm");
        }
      };
    },
  },
  components: { wxlogin },
};
</script>

<style lang="scss">
.login {
  width: 100%;
  height: 100%;
  min-width: 1300px;
  overflow: hidden;
  .item {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .wrap {
    min-width: 1300px;
    width: 1300px;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }
  .copywriting {
    position: absolute;
    left: 0;
    top: 38%;
  }
  .loginBox {
    overflow: hidden;
    width: 440px;
    height: 490px;
    background: #fff;
    padding: 55px;
    border-radius: 4px;
    position: absolute;
    top: 20%;
    right: 0;
    z-index: 10;
    .tab-head {
      text-align: center;
      margin-bottom: 55px;
      .item {
        font-size: 24px;
        color: #6b6b7d;
        padding: 0 16px;
        cursor: pointer;
        &.current {
          position: relative;
          color: #1a609f;
          &::after {
            content: "";
            position: absolute;
            bottom: -8px;
            left: 50%;
            transform: translateX(-50%);
            width: 70px;
            height: 1px;
            background: #1a609f;
            z-index: 11;
          }
        }
      }
    }
    .btn {
      width: 100%;
      margin-top: 50px;
      background: #1a609f;
      border-color: #1a609f;
      padding: 17px 20px;
    }
    .tisp {
      font-size: 20px;
      color: #909399;
      margin-top: 33px;
      text-align: center;
    }
    .codeBar {
      height: 222px;
      .code-show {
        margin: 0 auto;
        background: #f8fbfd;
        border: 1px solid #dcdfe6;
        box-shadow: 0 4px 8px 0 rgba(80, 86, 96, 0.1);
        width: 200px;
        height: 200px;
        border-radius: 10px;
        // overflow: hidden;
        padding: 6px;
      }
    }
  }
  .el-carousel__indicators--horizontal {
    bottom: 82px;
    z-index: 12;
  }
  .footer {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    text-align: center;
    font-size: 20px;
    color: rgba(255, 255, 255, 0.8);
    z-index: 11;
  }
}
.el-zoom-in-center-enter-active,
.el-zoom-in-center-leave-active {
  transition: all 0.4s ease;
}
.el-fade-in-enter-active,
.el-fade-in-leave-active {
  transition: all 0.5s ease;
}
</style>

